/**
 * @module Google Tag Manager
 * @description
 */
import React, { FC } from 'react';
import Script from 'next/script';

interface Props {
  accountId: string;
}

export const GTMScript: FC<Props> = ( { ...props } ) => {
  const {
    accountId
  } = props;

  return (
    <Script
      defer
      strategy="afterInteractive"
      src={ `https://www.googletagmanager.com/gtm.js?id=${ accountId }` }
    />
  );
}

GTMScript.displayName = 'GTMScript';

export const GTMSnippet: FC<Props> = ( { ...props } ) => {
  const {
    accountId
  } = props;

  return (
    <>
      <Script id="gtm-snippet" defer>
        { `(function (w, d, s, l, i) {
              w[l] = w[l] || []; w[l].push({
                  'gtm.start':
                      new Date().getTime(), event: 'gtm.js'
              }); var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${ accountId }');` }
      </Script>
      <noscript><iframe src={ `https://www.googletagmanager.com/ns.html?id=${ accountId }`} height="0" width="0" style={ { display: 'none', visibility: 'hidden' } }></iframe></noscript>
    </>
  );
}

GTMSnippet.displayName = 'GTMSnippet';
